import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/router/routes'
import authRouteGuard from '@/helpers/router/authRouteGuard'

const base =
  import.meta.env.VITE_APP_PUBLIC_PATH === undefined ? '/' : import.meta.env.VUE_APP_PUBLIC_PATH

const router = createRouter({
  history: createWebHistory(base),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { left: 0, top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  authRouteGuard(to, from, next)
})

export default router
